import { render, staticRenderFns } from "./TagsChart.component.vue?vue&type=template&id=5cad2504&scoped=true&"
import script from "./TagsChart.component.vue?vue&type=script&lang=js&"
export * from "./TagsChart.component.vue?vue&type=script&lang=js&"
import style0 from "./TagsChart.component.vue?vue&type=style&index=0&id=5cad2504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cad2504",
  null
  
)

export default component.exports